import { Button, CircularProgress, Grid2 } from "@mui/material";
type Props = {
	isSubmitLoading: boolean;
	disabled?: boolean;
	onHide: (update: boolean) => void;
	className?: string;
};
export const FooterDetailsButtons = ({
	isSubmitLoading,
	disabled = false,
	onHide,
	className,
}: Props) => {
	return (
		<Grid2 container spacing={2} justifyContent="flex-end">
			<Grid2
				size={{
					md: 3,
					xs: 12,
				}}
			>
				<Button
					data-test-id="close-button"
					fullWidth
					variant="contained"
					color="inherit"
					onClick={() => onHide(false)}
					className={className}
				>
					Close
				</Button>
			</Grid2>
			<Grid2
				size={{
					md: 3,
					xs: 12,
				}}
			>
				<Button
					data-test-id="save-button"
					fullWidth
					startIcon={isSubmitLoading && <CircularProgress size="1rem" />}
					disabled={isSubmitLoading || disabled}
					variant="contained"
					color="primary"
					type="submit"
					className={className}
				>
					Save
				</Button>
			</Grid2>
		</Grid2>
	);
};
